import { render, staticRenderFns } from "./SalesAndExpenses.vue?vue&type=template&id=5e3bb298"
import script from "./SalesAndExpenses.vue?vue&type=script&lang=js"
export * from "./SalesAndExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports